import React from 'react';

import Manufacturing from './Manufacturing';
import Productinform from './Productinform';
import Materialcharact from './Materialcharact';


const Dishposabl = () => {
    return (
        <div>
            <Manufacturing />
            <Productinform />
            <Materialcharact />
        </div>
    );
};

export default Dishposabl;
